export const RAILWAY_ENV_SYNC_SKIP_KEYS = new Set([
  'VERCEL_OIDC_TOKEN',
  'RAILWAY_TOKEN',
  'RAILWAY_API_TOKEN',
  'BETTERSTART_AUTH_URL',
  'NEXT_PUBLIC_BETTERSTART_AUTH_URL'
])
/**
 * `VERCEL_OIDC_TOKEN` is Vercel-owned link state, not app config. The auth URLs hold the local dev
 * origin; in production better-auth derives the base URL from the request and the client falls back
 * to `window.location.origin`, so pushing a localhost value would break auth.
 */
export const VERCEL_ENV_SYNC_SKIP_KEYS = new Set([
  'VERCEL_OIDC_TOKEN',
  'BETTERSTART_AUTH_URL',
  'NEXT_PUBLIC_BETTERSTART_AUTH_URL'
])
